export enum Criterion {
    Default = 'NERIB',
    OwnerAgeDefault = 'VIRS33',
    ExperienceOtherDriversDefault = 'VIRS10',
}
